/**
 * Storezone — RootRedirect
 *
 * Smart redirect from "/" based on the authenticated user's role.
 * Superadmin → /platform
 * Admin/Staff → /admin
 * Seller      → /pos
 * No membership → /auth/login
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { LoadingPage } from '@/components/states/LoadingPage'

export function RootRedirect() {
  const { loading, isSuperadmin, memberships } = useAuth()

  if (loading) return <LoadingPage />

  if (isSuperadmin) return <Navigate to="/platform" replace />

  if (memberships.length > 0) {
    const membership = memberships[0]
    if (membership.role_key === 'seller') return <Navigate to="/pos" replace />
    return <Navigate to="/admin" replace />
  }

  return <Navigate to="/auth/login" replace />
}
